import { motion } from 'framer-motion';

const CtaSection = () => {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-[#0B5FFF] to-[#4DA3FF] relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-48 sm:w-64 h-48 sm:h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-48 sm:w-64 h-48 sm:h-64 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 px-4">
            ¿Listo para transformar tu espacio?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-white/90 mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
            Contacta con <a href="https://grupocuartas.com/barcelona/" target="_blank" rel="noopener noreferrer" className="text-white underline hover:text-[#0A1B3D] transition-colors font-semibold">PLADUREX para tu proyecto de pladur en Barcelona</a>. Presupuesto sin compromiso en 24-48 horas. Trabajamos en viviendas ocupadas con total garantía.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-4">
            <a
              href="tel:+34629501941"
              className="group bg-white text-[#0B5FFF] px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold text-base sm:text-lg transition-all duration-300 hover:shadow-2xl hover:scale-105 flex items-center space-x-3 whitespace-nowrap w-full sm:w-auto justify-center max-w-sm"
            >
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-[#0B5FFF] rounded-full flex items-center justify-center group-hover:bg-[#0A1B3D] transition-colors flex-shrink-0">
                <i className="ri-phone-line text-white text-lg sm:text-xl"></i>
              </div>
              <span className="truncate">+34 629 501 941</span>
            </a>
            <a
              href="https://wa.me/34629501941"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-[#25D366] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold text-base sm:text-lg transition-all duration-300 hover:shadow-2xl hover:scale-105 flex items-center space-x-3 whitespace-nowrap w-full sm:w-auto justify-center max-w-sm"
            >
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-whatsapp-line text-white text-lg sm:text-xl"></i>
              </div>
              <span>WhatsApp</span>
            </a>
          </div>

          <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row flex-wrap items-center justify-center gap-4 sm:gap-6 text-white/80 text-xs sm:text-sm px-4">
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-lg sm:text-xl flex-shrink-0"></i>
              <span>Respuesta en 24h</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-lg sm:text-xl flex-shrink-0"></i>
              <span>Trabajo garantizado</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-home-smile-line text-lg sm:text-xl flex-shrink-0"></i>
              <span>Sin molestias</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CtaSection;
